import { useForm } from 'react-hook-form';
import loginService from './useLoginService';
import { message } from 'antd';
import { useState } from 'react';

export function useLogin() {
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const error = () => {
    message.open({
      type: 'error',
      content: 'Login error, check your credentials',
      className: 'custom-class',
      style: {
        marginTop: '15vh',
      },
    });
  };


  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await loginService.login(data);
      localStorage.setItem("accessToken", res.data.accessToken);
      localStorage.setItem("refreshToken", res.data.refreshToken);
      localStorage.setItem("userid",res.data.userid);

      window.location.href = "/";
    } catch (err) {
      console.error('Login error:', err);
      error("log in error, check your credentials");
    } finally {
      setLoading(false);
    }

  };

  return {
    handleSubmit,
    register,
    errors,
    onSubmit,
    loading
  };
}